{
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password",
    "layout": {
      "tagline": "Tanzania's Comedy Video Platform",
      "backToVideos": "Back to Videos"
    },
    "loginPage": {
      "title": "Log in to Kicheko",
      "noAccount": "Don't have an account yet?",
      "signUpLink": "Sign up",
      "usernameLabel": "Email or phone number",
      "usernamePlaceholder": "email{'@'}example.com or +255...",
      "passwordLabel": "Password",
      "rememberDevice": "Remember this device",
      "forgotPassword": "Forgot your password?",
      "submit": "Log in",
      "welcomeToast": "Welcome back to Kicheko!",
      "failed": "Login failed. Please check your credentials."
    },
    "signupPage": {
      "title": "Sign up for Kicheko",
      "haveAccount": "Already have an account?",
      "loginLink": "Log in here",
      "nameLabel": "Your full or stage name",
      "namePlaceholder": "e.g. Joti Mchekeshaji",
      "emailLabel": "Email",
      "emailPlaceholder": "you{'@'}example.com",
      "passwordLabel": "Password",
      "passwordHint": "Requires 8+ characters, a number, and a special character.",
      "confirmLabel": "Confirm password",
      "confirmRequired": "Please confirm your password",
      "passwordsMismatch": "Passwords don't match",
      "acceptTerms": "I agree to the Terms of Service and Privacy Policy",
      "acceptTermsRequired": "You must accept the terms and conditions",
      "submit": "Sign up",
      "welcomeToast": "Welcome to Kicheko! Your account is ready.",
      "failed": "Sign up failed. Please check your information.",
      "passwordRequired": "Password field is required",
      "passwordMinLength": "Password must be at least 8 characters long",
      "passwordLetter": "Password must contain at least one letter",
      "passwordNumber": "Password must contain at least one number",
      "passwordSpecial": "Password must contain at least one special character"
    },
    "passwordReset": {
      "title": "Forgot your password?",
      "intro": "Enter your email address and we'll send you a 6-digit code to reset your password.",
      "emailLabel": "Enter your email",
      "sendCode": "Send code",
      "goBack": "Go back",
      "checkEmail": "Check your email",
      "codeSent": "If an account exists for {email}, we've sent a 6-digit code. It expires in 10 minutes.",
      "otpLabel": "6-digit code",
      "otpInvalid": "Enter the 6-digit code",
      "verifyCode": "Verify code",
      "differentEmail": "Use a different email",
      "newPasswordTitle": "Set a new password",
      "newPasswordLabel": "New password",
      "repeatLabel": "Repeat new password",
      "repeatRequired": "Repeat Password field is required",
      "passwordsDontMatch": "Passwords don't match",
      "submit": "Reset password",
      "doneTitle": "Password updated",
      "doneText": "Your password has been reset. You can now log in with your new password.",
      "backToLogin": "Back to login",
      "genericError": "Something went wrong. Please try again."
    },
    "orContinueWith": "Or continue with",
    "google": {
      "welcomeToast": "Welcome to Kicheko!",
      "failed": "Google sign-in failed. Please try again."
    }
  },
  "validators": {
    "required": "This field is required",
    "email": "Please enter a valid email address"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "404": "404",
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "faq": "FAQ",
    "users": "Users",
    "projects": "Projects"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Support & Consulting",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  },
  "kicheko": {
    "tagline": "Laugh • Watch • Vote",
    "nav": {
      "home": "Home",
      "shorts": "Shorts",
      "comedians": "Comedians",
      "trending": "Trending",
      "library": "My Library",
      "liked": "Liked Videos",
      "upload": "Upload & Manage",
      "studio": "Studio (Dashboard)",
      "you": "You",
      "studioGroup": "Creator Studio"
    },
    "sidebar": {
      "creatorPromo": {
        "question": "Are you a Comedian?",
        "pitch": "Join Kicheko, upload your comedy and earn from your work.",
        "cta": "Start Today"
      },
      "footer": {
        "about": "About Us",
        "terms": "Terms",
        "privacy": "Privacy"
      }
    },
    "settings": {
      "title": "System Settings",
      "theme": {
        "label": "Theme",
        "description": "Choose your preferred dark or light appearance on the Kicheko platform."
      },
      "preferences": {
        "label": "Language & Preferences",
        "description": "Set the primary language to use on the site and your notifications."
      },
      "notifications": {
        "label": "Notification Settings",
        "description": "Choose the types of notifications you want to receive about new videos, comments and account activity."
      }
    },
    "home": {
      "hotBadge": "Trending Today",
      "watchNow": "Watch Now",
      "free": "Free",
      "videosAvailable": "{n} videos available",
      "noVideos": "No videos found",
      "noVideosDesc": "No videos in this category yet. Try selecting \"All\" or visit another category.",
      "showAll": "Show All Videos",
      "recommended": "Recommended Videos",
      "freeVideos": "Free Videos",
      "premiumVideos": "Premium Videos",
      "trending": "Most Watched in Tanzania",
      "comedy": "Comedy: {cat}",
      "shortsShelf": "Kicheko Shorts",
      "seeAll": "See all",
      "moreVideos": "More Videos"
    },
    "navbar": {
      "watchPlatform": "Watch Platform",
      "accountSettings": "Account Settings",
      "mySettings": "Settings"
    },
    "admin": {
      "nav": {
        "public": "Public Platform",
        "studio": "Kicheko Studio",
        "videos": "Upload & Manage Videos",
        "users": "Artists & Users",
        "payments": "Payments & Sales",
        "billing": "Sales Transactions",
        "paymentMethods": "Payment Methods",
        "pricingPlans": "Video Pricing",
        "profile": "Artist Profile",
        "settings": "System Settings",
        "faq": "Help & FAQ"
      }
    }
  },
  "taifa": {
    "layout": {
      "kichekoPro": "Kicheko Pro",
      "naniNiNani": "Nani ni Nani?",
      "wallOfFame": "Wall of Fame",
      "login": "Login",
      "logout": "Logout",
      "adminStudio": "Admin Studio",
      "back": "Back",
      "tagline": "Yakujivunia ni tele..."
    },
    "home": {
      "question": "Are you the next comedian?",
      "yes": "Yes",
      "feeNote": "One-time application fee: TSh {fee} — payable via mobile money",
      "step1Title": "1. Register Your Application",
      "step1Desc": "Fill your name, university and phone number — no payment needed.",
      "step2Title": "2. Nani ni Nani?",
      "step2Desc": "Watch campus comedy battles and vote for TSh 1,000 for your favorite.",
      "step3Title": "3. Wall of Fame",
      "step3Desc": "Meet legendary university comedy champions across Tanzania.",
      "voteTitle": "Kicheko Pro: Current Vote Standing",
      "votes": "votes",
      "vote": "Vote",
      "voteEmpty": "No contestants on the vote list yet.",
      "voteFor": "Vote for {name}",
      "feePerVote": "TSh {fee} per vote",
      "payerPhone": "Mobile money number",
      "totalToPay": "Total to pay",
      "payAndVote": "Pay TSh {amount} & vote",
      "approveOnPhone": "Approve the payment on your phone",
      "approveOnPhoneDesc": "Enter your PIN in the mobile money prompt. Your votes are added once payment is confirmed.",
      "votesAdded": "Your votes for {name} were added — now at {pct}%!",
      "voteFailed": "Payment failed — no votes were added.",
      "votePending": "Payment is still being confirmed. Your votes will appear once it completes.",
      "done": "Done",
      "liveLabel": "Live voting",
      "voteSubtitle": "Applications are closed — support your favourite comedian.",
      "contestantsShort": "Contestants",
      "colRank": "Rank",
      "colComedian": "Comedian",
      "colUniversity": "University",
      "colShare": "Share",
      "colVotes": "Votes",
      "voteFooter": "Share of all paid votes · TSh {fee} per vote via Pay-IT"
    },
    "register": {
      "createAccount": "Apply Now",
      "fillDetails": "Fill in your details to get started on your Kicheko Pro journey.",
      "firstName": "First Name",
      "firstNamePlaceholder": "Enter your first name",
      "lastName": "Last Name",
      "lastNamePlaceholder": "Enter your last name",
      "username": "Username",
      "usernamePlaceholder": "Choose a username",
      "email": "Email Address",
      "emailPlaceholder": "you{'@'}example.com",
      "university": "University",
      "selectUniversity": "Select your university",
      "phone": "Phone Number",
      "phoneNote": "We'll use this number to contact you about your application.",
      "alreadyRegisteredTitle": "You're Already Registered",
      "alreadyRegisteredDesc": "This phone number or email address already has a paid Kicheko Pro application — no need to apply again.",
      "back": "Back",
      "submit": "Submit",
      "confirmTitle": "Confirm Application & Pay Fee",
      "confirmFeeDesc": "Pay comedian registration fee of TSh 10,000",
      "step1Title": "1. Application Details",
      "step2Title": "2. Payment (PayIt)",
      "applicant": "Applicant",
      "feeBoxTitle": "Registration Fee",
      "selectPayment": "Select Payment Method:",
      "payViaPayit": "Pay TZS 10,000 with PayIt",
      "payInThisTab": "Or pay directly in this tab",
      "waitingPayment": "Waiting for payment confirmation… Approve the prompt on your phone.",
      "checkStatus": "Check Payment Status",
      "paymentProvider": "Secure Payment via PayIt",
      "supportedNetworks": "M-Pesa · Mixx by Yas · Airtel Money · Halopesa",
      "payAndSubmit": "Pay TSh 10,000 & Complete",
      "confirming": "Submitting...",
      "cancel": "Cancel",
      "paymentMethod": "Payment method",
      "mobileMoney": "Mobile Money",
      "payerPhone": "Phone number",
      "payerName": "Full name",
      "purpose": "Purpose (optional)",
      "purposeDefault": "Kicheko Application fees",
      "payNow": "Pay {amount}",
      "changeDetails": "Change phone / details",
      "promptSentTitle": "Payment prompt sent to your phone!",
      "promptSentDesc": "Please enter your PIN on your phone (+255 {phone}) to confirm the payment.",
      "invalidPhone": "Please enter a valid 9-digit phone number.",
      "orOpenPayit": "Or open PayIt checkout page",
      "successTitle": "Congratulations, Application Submitted!",
      "successDesc": "Your application and payment were received — it is pending Admin confirmation before appearing on Nani ni Nani or Wall of Fame.",
      "successDescPending": "Your application is registered and your payment is being confirmed — it will appear after admin review.",
      "paymentRef": "Application Reference:",
      "appRef": "Application Reference:",
      "viewNani": "Watch Nani ni Nani?",
      "returnHome": "Back to Home",
      "confirmingTitle": "Confirming your payment…",
      "confirmingDesc": "Please wait — we are confirming your payment with the provider. Do not close this page.",
      "title": "Comedian Registration",
      "next": "Next",
      "submitFailed": "We could not submit your application. Please try again.",
      "feeNotice": "Application fee: TSh {fee} — you will pay in the next step via mobile money."
    },
    "nani": {
      "title": "Nani ni Nani?",
      "subtitle": "Watch, compare and vote for the better comedian!",
      "roundOngoing": "Round #{round} in Progress",
      "votes": "Votes",
      "vote": "Vote",
      "completeVote": "Complete Your Vote",
      "payVoteDesc": "TSh {fee} per vote for {name} — paid securely via Pay-IT mobile money.",
      "amount": "Amount",
      "payVoteBtn": "Pay TSh {fee}",
      "verifyingVote": "Casting Vote...",
      "cancel": "Cancel",
      "votedSuccess": "You voted for {name} with TSh {fee}! Now at {pct}% of the votes",
      "voteDoneTitle": "Vote counted!",
      "done": "Done",
      "loading": "Loading battle...",
      "endedPill": "Round #{round} • Ended",
      "battleEnded": "Battle Ended",
      "battlesTitle": "Battles",
      "watchClip": "Watch Clip",
      "prevBattle": "Previous battle",
      "nextBattle": "Next battle",
      "ofVotes": "of the votes",
      "phonePlaceholder": "Mobile money number e.g. 0712 345 678",
      "approveOnPhone": "Approve the payment on your phone",
      "approveOnPhoneDesc": "Enter your PIN in the mobile money prompt. Your votes are counted once the payment is confirmed.",
      "voteFailed": "Payment failed — no votes were added.",
      "votePending": "Payment is still being confirmed. Your votes will appear once it completes.",
      "voteShare": "Vote share",
      "feeNote": "TSh {fee} per vote — charged via mobile money",
      "emptyTitle": "No battles yet",
      "emptyDesc": "New matchups are on the way — check back soon to vote."
    },
    "payment": {
      "loading": "Loading secure checkout…",
      "redirecting": "Redirecting to PayIt secure checkout…",
      "loadError": "We could not load the secure payment form.",
      "timeoutError": "The secure payment form did not load. You can still pay on the PayIt page.",
      "startError": "We could not start the secure payment form.",
      "successTitle": "Payment Received!",
      "successDesc": "We received your payment. Confirmation follows once the transfer settles.",
      "failedTitle": "Payment Not Completed",
      "failExhausted": "Every payment attempt failed. Start again to retry.",
      "failExpired": "This checkout session expired before it completed.",
      "failCancelled": "The checkout was cancelled.",
      "failGeneric": "The checkout ended without a successful payment.",
      "tryAgain": "Try Again",
      "openPayit": "Open PayIt page",
      "paymentRef": "Payment Reference:",
      "pageSuccessTitle": "Payment Complete",
      "pageSuccessDesc": "Thank you! Your payment was received and your application awaits admin review.",
      "pageFailedTitle": "Payment Not Completed",
      "pageFailedDesc": "The payment did not complete. You can try again from the application form.",
      "secureFooter": "Payments are processed securely by PayIt. Amounts are in TSh.",
      "payerPhoneLabel": "Mobile Money Number",
      "payerPhonePlaceholder": "712 345 678",
      "initiating": "Sending payment request…",
      "initiateError": "Could not send the payment request. Try again.",
      "promptSent": "Payment request sent — check your phone and approve the prompt to finish.",
      "done": "Done",
      "instructions": "Tap pay and a secure prompt will be pushed to your phone — approve it with your mobile money PIN to complete the payment.",
      "stepSent": "Payment prompt sent to your phone",
      "stepApprove": "Approve the prompt with your PIN",
      "stepConfirm": "Confirming your payment",
      "notReceived": "Didn't get the prompt? Go back",
      "pendingTitle": "Finish your registration payment",
      "pendingDesc": "You have an unfinished application payment — complete it to submit your entry.",
      "resumeBtn": "Complete Payment",
      "payLater": "Pay later"
    },
    "wall": {
      "title": "WALL OF FAME",
      "byTaifa": "by Taifa House",
      "home": "Home",
      "searchPlaceholder": "Search articles...",
      "categories": {
        "campuslife": "Campus Life",
        "fursamafanikio": "Success & Opportunities",
        "teknolojia": "Technology",
        "burudani": "Entertainment",
        "maishayachuo": "Student Stories",
        "maishayakijamii": "Social Life"
      },
      "advertise": {
        "kicker": "Sponsored",
        "title": "Advertise with us",
        "sub": "Reach thousands of students",
        "cta": "Learn more"
      },
      "trending": "Trending",
      "minRead": "{min} min read",
      "likesShort": "likes",
      "commentsShort": "comments",
      "share": "Share",
      "save": "Save",
      "backToFeed": "Back to articles",
      "comments": "Comments ({count})",
      "commentInput": "Write a comment...",
      "commentsSoon": "Comments are coming soon — the comments service is being wired up.",
      "emptyFeed": "No articles yet",
      "emptyFeedDesc": "New stories are on the way — check back soon.",
      "commentsRefresh": "Refresh",
      "commentsEmpty": "No comments yet — be the first!",
      "commentName": "Your name",
      "commentFailed": "Could not post your comment. Please try again.",
      "justNow": "just now",
      "minsAgo": "{n}m ago",
      "hoursAgo": "{n}h ago",
      "daysAgo": "{n}d ago",
      "loginToComment": "Log in to comment",
      "loginToCommentDesc": "You need to log in to post a comment.",
      "copyLink": "Copy link",
      "editComment": "Edit",
      "deleteComment": "Delete",
      "saveComment": "Save",
      "cancelEdit": "Cancel",
      "edited": "(edited)",
      "deleteCommentConfirm": "Delete this comment?",
      "commentUpdateFailed": "Couldn't update the comment.",
      "commentDeleteFailed": "Couldn't delete the comment."
    },
    "admin": {
      "title": "Main Management Studio",
      "subtitle": "Manage comedian applications, registration fees, Nani ni Nani battles and Wall of Fame.",
      "applicationsTitle": "Comedian Applications",
      "batches": {
        "nav": "Voting Batches",
        "title": "Voting Batches",
        "subtitle": "Organise approved comedians into titled voting rounds and promote winners to the next level.",
        "titleLabel": "Batch title",
        "titlePlaceholder": "e.g. IFM Comedian",
        "levelLabel": "Level",
        "levelValue": "Level {level}",
        "create": "Create batch",
        "selectBatch": "Choose a batch",
        "newOption": "+ New batch…",
        "newBatchTitle": "New batch title",
        "newBatchTitlePlaceholder": "Competition title",
        "newBatchLevel": "New batch level",
        "addToBatch": "Add to batch",
        "adding": "Adding…",
        "filterAll": "All batches",
        "filterNone": "No batch",
        "filterLabel": "Filter by batch",
        "openSuffix": "● Open",
        "openVotingNowConfirm": "Open voting for “{title}” now? It will appear on Kicheko Pro.",
        "noBatchVoteList": "No batch – not on vote list",
        "levelChangeConfirm": "Changing the level will remove this applicant from “{title}”. Continue?",
        "empty": "No voting batches yet. Create the first batch above.",
        "error": "The change could not be saved. Please try again.",
        "applicantCount": "{count} applicants",
        "openVoting": "Open voting",
        "closeVoting": "Close voting",
        "delete": "Delete",
        "deleteConfirm": "Delete “{title}”? Its applicants will return to level 1.",
        "selectApplicant": "Select applicant",
        "applicant": "Comedian",
        "university": "University",
        "votes": "Votes",
        "noApplicants": "No applicants in this batch.",
        "removeSelected": "Remove selected",
        "promoteTo": "Promote selected to…",
        "promote": "Promote",
        "addApplicants": "Add approved applicants",
        "currentBatch": "Currently in {title}",
        "noAvailableApplicants": "There are no other approved applicants to add.",
        "addSelected": "Add selected",
        "skipped": "{count} applicants were skipped because they are not approved.",
        "batchColumn": "Current batch",
        "selectedCount": "{count} selected"
      },
      "universitiesNav": "Universities",
      "totalApps": "Total Applications",
      "pendingApproval": "Pending Approval",
      "confirmedApps": "Confirmed / Approved",
      "feeRevenue": "Registration Fee Revenue",
      "all": "All Applications",
      "filterPending": "Pending Approval",
      "filterApproved": "Approved",
      "filterUnpaid": "Unpaid",
      "filterRejected": "Rejected",
      "searchPlaceholder": "Search name, university, phone...",
      "applicantTh": "Comedian",
      "universityTh": "University",
      "phoneTh": "Phone & Date",
      "feeTh": "Registration Fee",
      "statusTh": "Status",
      "actionsTh": "Actions",
      "approveBtn": "Approve",
      "rejectBtn": "Reject",
      "paidStatus": "TSh 10,000 Paid",
      "unpaidStatus": "Not Paid",
      "markPaid": "Mark as Paid",
      "refreshBtn": "Refresh",
      "deleteBtn": "Delete Application",
      "deleteConfirm": "Are you sure you want to delete this application?",
      "editBtn": "Edit",
      "deleteLabel": "Delete",
      "cancelBtn": "Cancel",
      "feeBadge": "Registration: Free",
      "totalAppsDesc": "Registered students",
      "pendingPaidDesc": "Paid, awaiting review",
      "confirmedDesc": "Official comedians",
      "feeRevenueTitle": "Fee Revenue (amount received)",
      "feeRevenueDesc": "Via M-Pesa / Tigo / Airtel",
      "feePaidLabel": "TSh {amount} (Paid)",
      "feeUnderpaidLabel": "TSh {amount} of {fee} (Underpaid)",
      "feeProcessingLabel": "Processing",
      "feePendingLabel": "Not Paid",
      "statusPendingAdmin": "Awaiting Admin Approval",
      "statusPendingFee": "Awaiting Registration Fee",
      "statusRejected": "Rejected",
      "emptyTitle": "No applications found",
      "emptyDesc": "No records match your filter.",
      "universities": {
        "title": "University Management",
        "count": "{count} Universities",
        "subtitle": "Manage the list of universities participating in competitions and shown on the Kicheko Pro registration form.",
        "addBtn": "Add New University",
        "statusActive": "Active",
        "statusInactive": "Disabled",
        "editTitle": "Edit University",
        "addTitle": "Add New University",
        "nameLabel": "Full University Name",
        "namePlaceholder": "e.g. University of Dar es Salaam",
        "codeLabel": "Abbreviation (Code)",
        "codePlaceholder": "e.g. UDSM",
        "locationLabel": "Region / Area",
        "locationPlaceholder": "e.g. Dar es Salaam",
        "badgeLabel": "Badge Image Path",
        "activeLabel": "This university is active for registration",
        "savingBtn": "Saving...",
        "saveBtn": "Save University",
        "deleteConfirm": "Are you sure you want to delete this university?"
      },
      "manageFame": {
        "title": "Wall of Fame Articles",
        "count": "{count} Articles",
        "subtitle": "Publish and manage the articles shown on the Wall of Fame feed.",
        "viewBtn": "View Feed",
        "addBtn": "Add Article",
        "deleteTitle": "Delete Article",
        "editTitle": "Edit Article",
        "addTitle": "Add New Article",
        "titleLabel": "Title",
        "categoryLabel": "Category",
        "excerptLabel": "Excerpt (short summary)",
        "bodyLabel": "Article body",
        "readTimeLabel": "Read time (min)",
        "imageLabel": "Cover image",
        "saveBtn": "Save Article",
        "deleteConfirm": "Are you sure you want to delete this article?"
      },
      "nani": {
        "title": "\"Nani ni Nani?\" Management",
        "subtitle": "Arrange university comedian battles, track votes and the TSh 1,000 fee per vote.",
        "viewBtn": "View Live Stage",
        "resetBtn": "Reset",
        "totalVotesLabel": "Total Votes Cast",
        "totalVotesDesc": "All votes in the active battle",
        "revenueLabel": "Vote Revenue (TSh 1,000 / Vote)",
        "revenueDesc": "Revenue from voters in Tanzania",
        "leaderLabel": "Leading Comedian",
        "tie": "Tie",
        "votesText": "{votes} votes",
        "contestantATitle": "Contestant A (Left Side)",
        "contestantBTitle": "Contestant B (Right Side)",
        "votesBadge": "{votes} Votes ({pct}%)",
        "nameLabel": "Full Name",
        "codeLabel": "University Abbreviation",
        "initialVotesLabel": "Initial Vote Count",
        "saveBtn": "Save Contestant Changes",
        "savedMsg": "Changes saved successfully!",
        "resetVotesBtn": "Reset All Votes to 0",
        "resetVotesConfirm": "Are you sure you want to reset all votes to zero (0)?",
        "battlesCount": "{count} Battles",
        "newBattleBtn": "New Battle",
        "newBattleTitle": "Create New Battle",
        "editBattleTitle": "Edit Battle",
        "titleLabel": "Battle Title",
        "roundLabel": "Round",
        "feeLabel": "Vote Fee (TSh)",
        "categoryLabel": "Entertainment Category",
        "categoryNone": "No Category",
        "statusLabel": "Status",
        "statusDraft": "Draft",
        "statusActive": "Live",
        "statusEnded": "Ended",
        "badgeLabel": "University Badge",
        "videoUrlLabel": "Video URL (YouTube)",
        "activateBtn": "Activate",
        "emptyBattles": "No battles yet — create your first battle.",
        "deleteBattleConfirm": "Are you sure you want to delete this battle?",
        "themeColorLabel": "Theme Color",
        "feeFixed": "The vote fee is fixed at TSh 1,000",
        "colBattle": "Battle",
        "colContestantA": "Contestant A",
        "colContestantB": "Contestant B"
      },
      "videos": {
        "title": "Kicheko Video Management & Upload",
        "subtitle": "Upload new comedy videos, create short Shorts previews, set pricing and manage content.",
        "uploadBtn": "Upload New Video",
        "statTotal": "Total Videos",
        "statPaid": "Paid Videos",
        "statShorts": "Shorts / Previews",
        "statViews": "Total Views",
        "tableTitle": "Videos in the System",
        "videoCount": "{count} videos",
        "thVideo": "Video / Title",
        "thArtist": "Artist",
        "thCategory": "Category",
        "thAccess": "Access Type",
        "thViews": "Views",
        "durationLabel": "Duration: {duration}",
        "paidBadge": "Paid: Tsh {price}",
        "viewLink": "View",
        "modalTitle": "Upload New Kicheko Video",
        "titleLabel": "Video Title *",
        "titlePlaceholder": "e.g. Cheka Tu Live: Dar es Salaam Comedy...",
        "descLabel": "Video Description",
        "descPlaceholder": "Briefly describe the content of this comedy show...",
        "comedianLabel": "Artist / Comedian *",
        "categoryLabel": "Category *",
        "accessLabel": "Access Type",
        "accessFree": "Free",
        "accessPaid": "Paid",
        "priceLabel": "Video Price (TZS) *",
        "videoUrlLabel": "Video File URL (mp4 / webm)",
        "thumbUrlLabel": "Thumbnail Image URL",
        "shortLabel": "This is a Short Preview (9:16 short video linked to the main video)",
        "cancelBtn": "Cancel",
        "submittingBtn": "Uploading...",
        "submitBtn": "Publish Video Now",
        "uploadSuccess": "Video uploaded and published successfully!"
      },
      "applicationsOpenBtn": "Applications: Open",
      "applicationsClosedBtn": "Applications: Closed",
      "levelTh": "Level",
      "levelLabel": "Level {n}",
      "onVoteList": "Visible on the public vote list",
      "notOnVoteList": "Not on the vote list yet",
      "flowHint": "Flow: applicant pays (or you mark-paid) → Approve → close applications → select approved applicants and “Add to batch” (competition title + level 2–4) → open voting for that batch on the Voting Batches page so it appears on Kicheko Pro.",
      "bulkSelected": "{n} selected",
      "bulkHint": "Approved applicants only — others are skipped.",
      "bulkApply": "Set level",
      "bulkUpdating": "Updating…",
      "bulkClear": "Clear",
      "bulkSelectAll": "Select all approved",
      "levelNeedsApproval": "Approve the application first — levels apply to approved applicants only.",
      "bulkSkipped": "{n} application(s) were skipped because they are not approved.",
      "voteFeeLabel": "Vote fee (TSh)",
      "appFeeLabel": "Application fee (TSh)",
      "saveBtn": "Save"
    },
    "voteStats": {
      "nav": "Vote Stats",
      "title": "Vote Stats",
      "subtitle": "Every vote purchase — Kicheko Pro and Nani ni Nani",
      "tabKicheko": "Kicheko Pro",
      "tabNani": "Nani ni Nani",
      "purchases": "Purchases",
      "purchasesDesc": "All payment attempts",
      "confirmed": "Confirmed",
      "confirmedDesc": "Completed payments",
      "votesCast": "Votes Cast",
      "votesCastDesc": "Confirmed votes tallied",
      "revenue": "Revenue",
      "revenueDesc": "TSh collected",
      "leaderboard": "Leaderboard",
      "recentPurchases": "Recent Purchases",
      "colVotedFor": "Voted for",
      "colVotes": "Votes",
      "colAmount": "Amount",
      "colStatus": "Status",
      "colPhone": "Phone",
      "colTime": "Time",
      "statusPaid": "Paid",
      "statusPending": "Pending",
      "statusFailed": "Failed",
      "empty": "No votes yet",
      "justNow": "just now",
      "updatedAt": "Updated {time}"
    },
    "dashboard": {
      "liveOnline": "Live Online",
      "viewPlatform": "View Platform",
      "reviewApps": "Review Applications",
      "appsCard": "Comedian Applications",
      "approved": "Approved",
      "newApps": "new",
      "feeCard": "Registration Fees",
      "feeFrom": "From registered comedians",
      "naniVotesCard": "\"Nani ni Nani?\" Votes",
      "revenue": "Revenue",
      "perVote": "(1,000 TSh / Vote)",
      "fameCard": "Wall of Fame",
      "fameApproved": "Officially approved champions",
      "activeBattle": "Active Battle: \"Nani ni Nani?\"",
      "voteFeeNote": "Viewers cast votes for TSh 1,000",
      "manageBattle": "Manage Battle",
      "recentApps": "Recent Comedian Applications",
      "recentAppsDesc": "Comedians who registered recently",
      "viewAll": "View All",
      "applicantTh": "Comedian",
      "universityTh": "University",
      "feeTh": "Fee (TSh)",
      "statusTh": "Status",
      "actionsTh": "Action",
      "paid": "Paid",
      "unpaid": "Pending",
      "statusApproved": "Approved",
      "statusPendingReview": "Pending Review",
      "approveBtn": "Approve",
      "complete": "Complete"
    },
    "pages": {
      "common": {
        "followers": "{count} followers",
        "views": "{count} views",
        "follow": "Follow",
        "following": "Following",
        "share": "Share",
        "followedToast": "You are now following {name}!",
        "unfollowedToast": "You unfollowed {name}."
      },
      "comedians": {
        "title": "Kicheko Comedians of Tanzania",
        "subtitle": "Discover popular and up-and-coming comedians, watch their work and follow them.",
        "verified": "Verified",
        "viewWork": "View Work"
      },
      "profile": {
        "videosCount": "{count} videos",
        "allVideos": "All Videos ({count})",
        "shortsTab": "Shorts ({count})",
        "noVideos": "This artist has not uploaded any long videos yet.",
        "noShorts": "This artist has no Shorts yet."
      },
      "search": {
        "resultsFor": "Search results for:",
        "videosFound": "{count} videos found",
        "placeholder": "Search video title or artist...",
        "noResults": "No results found",
        "noResultsHint": "Try other words like \"Joti\", \"Cheka Tu\", \"Mpoki\", or \"Skits\"."
      },
      "shorts": {
        "counter": "{current} of {total}",
        "nextTitle": "Next Short",
        "next": "Next",
        "watchFull": "Watch Full Video",
        "empty": "No Shorts available right now.",
        "likedToast": "You liked this Short!",
        "linkCopied": "Short link copied to clipboard!"
      },
      "watch": {
        "buy": "Buy",
        "share": "Share",
        "upNext": "Up Next",
        "paid": "Paid",
        "showMore": "Show more",
        "showLess": "Show less",
        "paymentTitle": "Kicheko Video Payment",
        "buyAccess": "Buy access to watch:",
        "amountDue": "Amount to Pay:",
        "phoneLabel": "Payment Phone Number:",
        "phonePlaceholder": "07XXXXXXXX or +255...",
        "verifying": "Verifying...",
        "payNow": "Pay Now",
        "loading": "Loading video...",
        "likedToast": "You liked this video!",
        "linkCopied": "Video link copied to clipboard!"
      },
      "library": {
        "title": "My Kicheko Library",
        "subtitle": "Here you'll find the videos you purchased and the ones you liked.",
        "purchasedTab": "Purchased Videos ({count})",
        "likedTab": "Liked ({count})",
        "noPurchased": "You haven't purchased any videos yet",
        "noPurchasedDesc": "When you buy premium videos from your favorite artists, they'll appear here for unlimited viewing.",
        "browseCta": "Watch Videos Now",
        "noLiked": "You have no liked videos yet",
        "noLikedDesc": "Click the 'Like' button on any Kicheko video to save it here."
      },
      "fame": {
        "loading": "Loading Wall of Fame...",
        "emptyTitle": "No Champions Yet",
        "emptyDesc": "Kicheko Pro champions will be listed here soon."
      },
      "pro": {
        "logoAlt": "Kicheko Pro - Get Ready to Laugh"
      },
      "register": {
        "paymentAlt": "Payment"
      },
      "nani": {
        "cardOption": "Credit / Debit Card",
        "cardsAlt": "Cards"
      }
    },
    "misc": {
      "common": {
        "name": "Name",
        "save": "Save",
        "edit": "Edit",
        "delete": "Delete",
        "search": "Search",
        "status": "Status",
        "team": "Team",
        "export": "Export",
        "today": "Today",
        "week": "Week",
        "month": "Month",
        "noProjects": "No projects"
      },
      "users": {
        "active": "Active",
        "inactive": "Inactive",
        "addUser": "Add User",
        "editUser": "Edit user",
        "add": "Add",
        "userUpdated": "{name} has been updated",
        "userCreated": "{name} has been created",
        "userDeleted": "{name} has been deleted",
        "unsavedChanges": "Form has unsaved changes. Are you sure you want to close it?",
        "addImage": "Add image",
        "fullName": "Full Name",
        "role": "Role",
        "roleAdmin": "Admin",
        "roleUser": "User",
        "roleOwner": "Owner",
        "notes": "Notes",
        "deleteUser": "Delete user",
        "deleteConfirm": "Are you sure you want to delete {name}?",
        "moreProjects": "{names} + {count} more",
        "results": "{n} results.",
        "resultsPerPage": "Results per page",
        "prevPage": "Previous page",
        "nextPage": "Next page"
      },
      "preferences": {
        "nameChanged": "You've successfully changed your name",
        "oldPassword": "Old password",
        "newPassword": "New password",
        "repeatNewPassword": "Repeat new password",
        "min8Chars": "Must be at least 8 characters long",
        "unique6Chars": "Must contain at least 6 unique characters",
        "updatePassword": "Update Password",
        "passwordChanged": "You've successfully changed your password",
        "oldPasswordRequired": "Old password field is required",
        "newPasswordRequired": "New password field is required",
        "passwordSame": "New password cannot be the same",
        "repeatPasswordRequired": "Repeat new password field is required",
        "passwordMismatch": "Confirm password does not match new password",
        "memberSince": "Member since",
        "twoFA": "Two-factor authentication",
        "twoFASetup": "Set up 2FA",
        "twoFADisable": "Disable 2FA",
        "twoFAEnabledDesc": "Two-Factor Authentication (2FA) is now enabled for your account, adding an extra layer of security to your sign-ins.",
        "twoFADisabledDesc": "Add an extra layer of security to your account. To sign in, you’ll need to provide a code along with your username and password.",
        "twoFAEnabled": "2FA successfully enabled",
        "twoFADisabled": "2FA successfully disabled",
        "emailSubscriptions": "Email subscriptions",
        "manageEmails": "To manage what emails you get, visit the",
        "nameChangeFailed": "Could not update your name. Please try again."
      },
      "faq": {
        "title": "How can we help you?",
        "noMatches": "No matches found. Try refining your search or browse through the categories to find the help you need.",
        "popularQuestions": "Popular questions",
        "q1Title": "How do I reload a page?",
        "q1Intro": "Get ready for some page-refreshing wisdom! We're about to dive into the magical world of reloading web pages. Here are some techniques:",
        "q1Step1": "Press the F5 key or Ctrl + R (Windows/Linux) or Command + R (Mac) to manually reload the current page.",
        "q1Step2": "Click the reload button in your browser. It usually looks like a circular arrow and is typically located in the address bar.",
        "q1Step3": "Use JavaScript to reload the page programmatically: location.reload();",
        "q2Title": "What is a Secure Key?",
        "q2P1": "A Secure Key is an extra layer of security that helps look after you and your money by generating a unique, single use security code every time you log on or authorise a payment. There are two types of Secure Key - a Digital version that works as part of the Mobile Banking App - perfect if you have a smartphone or tablet. Or, you can use a Physical version that is a little key ring that looks like a mini calculator.",
        "q2P2": "We recommend setting up a Digital Secure Key. It’s built into the first direct Banking App, and if you have the right type of smartphone you can use your fingerprint or face recognition to seamlessly log on or authorise payments.",
        "q2Link": "Find out more about Secure Keys",
        "q3Title": "How do I report fraud?",
        "q3P1": "Reporting fraud is a serious matter, and it's important to take appropriate steps to address and prevent fraudulent activities. The specific process for reporting fraud may vary based on your location and the nature of the fraud, but here's a general guide:",
        "q3Li1Bold": "Report to Relevant Authorities:",
        "q3Li1Text": "Depending on the nature of the fraud, you may need to report to other relevant authorities, such as the Securities and Exchange Commission (SEC) for investment-related fraud or the Better Business Bureau (BBB) for scams and deceptive practices.",
        "q3Li2Bold": "Document All Details:",
        "q3Li2Text": "Make sure to document all the relevant details about the fraud, including dates, times, names of individuals involved (if known), financial transactions, and any communication related to the fraud.",
        "q3Li3Bold": "Report to Internet Crime Organizations:",
        "q3Li3Text": "If the fraud involves online activities, consider reporting to organizations that deal with internet crimes, such as the Internet Crime Complaint Center (IC3). IC3 is a partnership between the FBI and the National White Collar Crime Center.",
        "q3P2": "Remember to act promptly and follow the specific reporting procedures relevant to your location and the type of fraud you've encountered. Taking swift action can help mitigate potential damage and prevent further fraudulent activities.",
        "q4Title": "How to download statements?",
        "q4P1": "Downloading statements can vary depending on the type of statements you're referring to (e.g., bank statements, credit card statements, utility statements). Below are general steps to download statements from various platforms:",
        "q4Li1Bold": "Ensure Secure Connection:",
        "q4Li1Text": "Always access and download statements from a secure and trusted network to protect your sensitive financial information.",
        "q4Li2Bold": "Regularly Check Statements:",
        "q4Li2Text": "Review your statements regularly to verify transactions, detect errors, or identify any suspicious activity promptly.",
        "q4Li3Bold": "Verify Account Details:",
        "q4Li3Text": "Ensure that the statements you download correspond to the correct account, including account numbers and account names.",
        "q4Li4Bold": "Use Official Channels:",
        "q4Li4Text": "Download statements only from official and authorized platforms, such as your bank's official website or the secure online portals of service providers.",
        "q4P2": "Always ensure that you follow the specific steps and instructions provided by the respective service provider to download statements securely and accurately. If you encounter any difficulties or have specific questions, consider reaching out to the customer support of the respective institution or service.",
        "gotQuestions": "Got questions?",
        "demoPitch": "Request a free demo to have all your questions answered by an expert.",
        "requestDemo": "Request a demo",
        "sendMessageAlt": "Send a message",
        "requestFreeDemo": "Request free demo",
        "demoModalPitch": "Claim your spot now and ignite innovation with our exceptional software solution! 🔥",
        "emailRequired": "Email field is required",
        "emailInvalid": "Email should be valid",
        "demoSubmittedTitle": "Demo Request Submitted!",
        "demoSubmittedMsg": "An expert will get in touch soon"
      },
      "notFound": {
        "title": "Page not found",
        "message": "The page you are looking for might have been removed had its name changed or is temporarily unavailable.",
        "goHome": "Go to homepage",
        "githubIssue": "Create a GitHub issue"
      },
      "studio": {
        "totalVideos": "Total Videos",
        "thisMonth": "this month",
        "videosSplit": "{long} long • {short} shorts",
        "totalViews": "Total Views",
        "growth": "growth",
        "avgPerVideo": "Avg {n}/video",
        "revenueLabel": "Content Revenue (TZS)",
        "sales": "sales",
        "likesEngagement": "Likes & Engagement",
        "engagement": "engagement",
        "comedians": "{n} comedians"
      },
      "activity": {
        "title": "Platform Activity (Live)",
        "subtitle": "Recent events and transactions on Kicheko",
        "live": "Live",
        "cdnStatus": "Video Server Health (Streaming CDN):",
        "cdnHealthy": "100% Stable (Normal)",
        "act1Title": "M-Pesa Payment Confirmed",
        "act1Desc": "User +255 754 *** completed Tsh 2,500 for video \"Cheka Tu Live Season 4\".",
        "act1Time": "3 minutes ago",
        "act2Title": "New Short Uploaded",
        "act2Desc": "Joti published a new Short video: \"Ushauri wa Mtaa\".",
        "act2Time": "18 minutes ago",
        "act3Title": "Viewership Milestone",
        "act3Desc": "The video \"Vituko vya Kariakoo\" crossed 850,000 views today!",
        "act3Time": "1 hour ago",
        "act4Title": "Tigo Pesa Payment Confirmed",
        "act4Desc": "User +255 713 *** completed Tsh 1,500 for video \"Harusi ya Shoki\".",
        "act4Time": "2 hours ago",
        "act5Title": "New Comedian Joined",
        "act5Desc": "Mau Fundi has been officially verified and their account activated on Kicheko.",
        "act5Time": "4 hours ago"
      },
      "revenue": {
        "mobileMoney": "Mobile Money Payments",
        "subtitle": "Revenue split across Tanzanian providers",
        "successRate": "{n}% Succeeded",
        "transactions": "{n} transactions",
        "ofRevenue": "{n}% of revenue",
        "settlement": "Payments are settled:",
        "settlementFreq": "Every Friday (Weekly)",
        "tooltipRevenue": "{label}: {n}% of revenue"
      },
      "leaderboard": {
        "title": "Top Comedians",
        "subtitle": "Top artists with the biggest influence on the platform",
        "followers": "followers",
        "addArtist": "Want to add a new artist?",
        "uploadContent": "Upload Their Content"
      },
      "topVideos": {
        "title": "Top Videos by Views (Top Content)",
        "subtitle": "Content leading in views and revenue on the platform",
        "manageAll": "Manage All Videos",
        "thVideo": "Video / Content",
        "thArtist": "Artist",
        "thCategory": "Category",
        "thPrice": "Price",
        "thViews": "Views",
        "thLikes": "Likes",
        "thAction": "Action",
        "shortBadge": "Short",
        "watchVideo": "Watch Video"
      },
      "analytics": {
        "title": "Viewing & Engagement Trends",
        "subtitle": "Real statistics of viewers and engagement on Kicheko videos",
        "viewsTab": "Views",
        "revenueTab": "Revenue (TZS)",
        "likesTab": "Likes",
        "watchTime": "Watch Time",
        "avgPerVideo": "Avg per Video",
        "returnRate": "Return Rate",
        "viewsLabel": "Views (Thousands)",
        "revenueLabel": "Revenue (Millions TZS)",
        "likesLabel": "Likes (Thousands)",
        "months": "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec"
      },
      "cards": {
        "monthlyEarnings": "Monthly Earnings",
        "lastMonth": "last month",
        "viewAllProjects": "View all projects",
        "revenueByRegion": "Revenue by Top Regions",
        "topRegion": "Top Region",
        "revenueByLocation": "Revenue by location",
        "countries": "Countries",
        "revenueReport": "Revenue Report",
        "totalEarnings": "Total earnings",
        "earningsThisMonth": "Earnings this month",
        "expenseThisMonth": "Expense this month",
        "timeline": "Timeline",
        "yearlyBreakup": "Yearly Breakup",
        "lastYear": "last year",
        "earnings": "Earnings",
        "profit": "Profit",
        "sinceLastMonth": "since last month"
      },
      "metrics": {
        "openInvoices": "Open invoices",
        "ongoingProjects": "Ongoing project",
        "employees": "Employees",
        "newProfit": "New profit"
      },
      "timeline": {
        "updatedStatusOf": "updated the status of",
        "toAwaitingResponse": "to awaiting customer response",
        "addedToGroup": "was added to the group",
        "groupNamed": "group name is {name}",
        "openedShowcase": "opened new showcase",
        "withTheme": "with theme {theme}",
        "updatedStatusTo": "updated the status to awaiting customer response",
        "projectWord": "Project",
        "wasCreated": "was created"
      },
      "navbar": {
        "applicationsTitle": "Comedian Applications",
        "applications": "Applications",
        "toLight": "Switch to light mode",
        "toDark": "Switch to dark mode"
      },
      "ytNav": {
        "toggleMenu": "Toggle menu",
        "searchPlaceholder": "Search comedy videos, artists, skits...",
        "searchPlaceholderMobile": "Search comedy videos...",
        "uploadVideo": "Upload Video",
        "defaultUser": "Kicheko User",
        "avatarAlt": "Avatar",
        "loggedOut": "You have been logged out safely."
      }
    }
  }
}
